export { ViewResourceTypes } from './ViewResourceTypes';
